<template>
  <div class="container ctpx-sticker-signup">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <form
          class="steps"
          v-if="!validSubmit"
          :style="{ height: tallestStepHeight + 'px' }"
          @submit.prevent="stickerSubmit"
        >
          <div
            class="modal-step step-one"
            :class="[stepOne ? 'active' : 'out']"
          >
            <h1 class="display-2">
              Join the herd and get a free llama sticker.
            </h1>
            <div class="row">
              <div class="form-group col-12">
                <label class="d-none" for="inputEmail">Email</label>
                <input
                  type="email"
                  name="email"
                  class="form-control"
                  v-model="email"
                  id="inputEmail"
                  placeholder="Email..."
                />
                <div v-if="emailError" class="form-error">
                  <small>{{ emailError }}</small>
                </div>
              </div>
              <!-- .form-group -->
            </div>
            <!-- .row -->
            <div class="row">
              <div class="form-group col-12">
                <button
                  type="button"
                  class="btn btn-black btn-block"
                  @click="nextStep()"
                >
                  Continue
                </button>
              </div>
              <!-- .form-group -->
            </div>
            <!-- .row -->
            <p>
              <small
                >*By submitting your email address you are agreeing to receive
                promotions and updates from Cotopaxi. This is a solid life
                choice, but we want you to know that you can also opt out at any
                time. View our
                <a href="/pages/privacy-policy">privacy policy</a>.</small
              >
            </p>
          </div>
          <!-- .step-one -->
          <div
            class="modal-step step-two"
            :class="[!stepOne ? 'active' : 'out']"
          >
            <h1 class="display-2">
              Great! Now we just need to know where to send your sticker.
            </h1>
            <div class="row gx-4">
              <div class="form-group col-6">
                <label class="d-none" for="inputFirstName">first name</label>
                <input
                  type="text"
                  name="text"
                  class="form-control"
                  v-model="first_name"
                  id="inputFirstName"
                  placeholder="First Name"
                />
                <div v-if="firstNameError" class="form-error">
                  <small>{{ firstNameError }}</small>
                </div>
              </div>
              <!-- .form-group -->
              <div class="form-group col-6">
                <label class="d-none" for="inputLastName">last name</label>
                <input
                  type="text"
                  name="text"
                  class="form-control"
                  v-model="last_name"
                  id="inputLastName"
                  placeholder="Last Name"
                />
                <div v-if="lastNameError" class="form-error">
                  <small>{{ lastNameError }}</small>
                </div>
              </div>
              <!-- .form-group -->
            </div>
            <!-- .row -->
            <div class="row">
              <div class="form-group">
                <label class="d-none" for="inputAddress">address</label>
                <input
                  type="text"
                  name="text"
                  class="form-control"
                  v-model="address"
                  id="inputAddress"
                  placeholder="Address"
                />
                <div v-if="addressError" class="form-error">
                  <small>{{ addressError }}</small>
                </div>
              </div>
              <!-- .form-group -->
            </div>
            <!-- .row -->
            <div class="row">
              <div class="form-group">
                <label class="d-none" for="inputCity">city</label>
                <input
                  type="text"
                  name="city"
                  class="form-control"
                  v-model="city"
                  id="inputCity"
                  placeholder="City"
                />
                <div v-if="cityError" class="form-error">
                  <small>{{ cityError }}</small>
                </div>
              </div>
              <!-- .form-group -->
            </div>
            <!-- .row -->
            <div class="row gx-4">
              <div class="form-group col-6">
                <label class="d-none" for="inputState">state</label>
                <input
                  type="text"
                  name="state"
                  class="form-control"
                  v-model="state"
                  id="inputState"
                  maxlength="2"
                  placeholder="State"
                />
                <div v-if="stateError" class="form-error">
                  <small>{{ stateError }}</small>
                </div>
              </div>
              <!-- .form-group -->
              <div class="form-group col-6">
                <label class="d-none" for="inputZip">zip</label>
                <input
                  type="text"
                  name="zip"
                  class="form-control"
                  v-model="zip"
                  id="inputZip"
                  maxlength="5"
                  placeholder="Zip"
                />
                <div v-if="zipError" class="form-error">
                  <small>{{ zipError }}</small>
                </div>
              </div>
              <!-- .form-group -->
            </div>
            <!-- .row -->
            <div class="form-group">
              <button type="submit" class="btn btn-black btn-block">
                Finish
              </button>
            </div>
            <!-- .form-group -->
            <div class="go-back" @click="stepOne = true">Go back</div>
            <p>
              <small
                >*By submitting your email address you are agreeing to receive
                promotions and updates from Cotopaxi. This is a solid life
                choice, but we want you to know that you can also opt out at any
                time. View our
                <a href="/pages/privacy-policy">privacy policy</a>.</small
              >
            </p>
          </div>
          <!-- .step-two -->
        </form>
        <div v-else class="steps">
          <div class="modal-step step-tree active">
            <h1 class="display-2">Success!</h1>
            <h3 class="display-4">Look for that llama sticker any day now.</h3>
            <p>
              <small
                ><em
                  >Please allow up to 4 weeks for us to process your
                  request.</em
                ></small
              >
            </p>
          </div>
        </div>
      </div>
      <!-- .col -->
    </div>
    <!-- .row -->
  </div>
  <!-- .container -->
</template>

<script src="./ctrl-sticker-signup.js"></script>
